<template>
  <div :class="typeData.class">
    <span class="icon-mapit">{{ typeData.icon }}</span>
    <div class="info-text" v-html="text" />
  </div>
</template>

<script lang="ts">
import {computed, defineComponent, PropType, ref} from '@vue/composition-api'

import {ResultStatus} from '@/types'
import {TypeResultStylesData} from '@/types'

export default defineComponent({
  name: 'ResultInfoBox',
  props: {
    type: {
      type: String as PropType<ResultStatus | undefined>,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const cancelDialog = ref<boolean>(false)

    const typeData = computed((): TypeResultStylesData => {
      switch (props.type) {
        case ResultStatus.ERROR:
          return {
            icon: 'T',
            class: 'result-info-box-error',
          }
        case ResultStatus.WARNING:
          return {
            icon: 'T',
            class: 'result-info-box-warning',
          }
        case ResultStatus.SUCCESS:
          return {
            icon: 'R',
            class: 'result-info-box-success',
          }
        default:
          return {
            icon: 'R',
            class: 'result-info-box-transp',
          }
      }
    })

    return {
      cancelDialog,
      typeData,
    }
  },
})
</script>
<style lang="scss" scoped>
.result-info-box {
  &-success,
  &-warning,
  &-error,
  &-transp {
    padding: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    .info-text {
      text-align: left;
      font: normal normal 600 16px/20px 'ProximaNovaSemibold';
      letter-spacing: 0px;
      padding-left: 15px;
    }
  }

  &-transp {
    visibility: hidden;
  }
  &-success {
    background: rgba(0, 128, 62, 0.1) 0% 0% no-repeat padding-box;
    color: var(--v-secondary-base);
  }
  &-warning {
    background: rgba(252, 164, 0, 0.1) 0% 0% no-repeat padding-box;
    color: var(--v-warning-base);
  }
  &-error {
    background: rgba(220, 24, 45, 0.1) 0% 0% no-repeat padding-box;
    color: var(--v-primary-base);
  }
}
</style>
